import React, { useMemo } from 'react';
import { ScreenContainer, ContentFrame, LayoutContentHeader, } from '@pinwheel/origami';
import TemplateForm from '../../LinkApiRouter/components/TemplateForm/TemplateForm';
import TitleFrame from '../../LinkApiRouter/components/TitleFrame';
import ModalHeader from '../../components/ModalHeader';
import { useDDFormContext } from '../../hooks/useDDFormContext';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
var MultipleAccountSelection = function () {
    var _a = useDDFormContext(), goBack = _a.goBack, bankInfos = _a.bankInfos, setBankInfos = _a.setBankInfos;
    var getLocalizedString = useGetLocalizedString();
    var navigate = useLinkNavigate();
    var handleSubmit = function (value) {
        var newBankInfos = JSON.parse(JSON.stringify(bankInfos));
        if (bankInfos) {
            newBankInfos.forEach(function (bankInfo) {
                bankInfo.selected = false;
            });
            newBankInfos[+value.multiple_account_selection].selected = true;
            setBankInfos(newBankInfos);
        }
        navigate('/dd-form/confirmation-screen');
    };
    var userField = useMemo(function () {
        var displayOptions = bankInfos
            ? bankInfos.map(function (bankInfo, i) { return ({
                value: i.toString(),
                label: "".concat(bankInfo.name, " *").concat(bankInfo.accountNumberLastFour),
            }); })
            : [{ value: '', label: '' }];
        return {
            key: 'multiple_account_selection',
            label: '',
            fieldType: 'select_single',
            required: true,
            options: displayOptions,
        };
    }, [bankInfos]);
    return (React.createElement(ScreenContainer, null,
        React.createElement(ModalHeader, { onBack: goBack }),
        React.createElement(LayoutContentHeader, { sx: { padding: '0px' } },
            React.createElement(TitleFrame, { title: getLocalizedString('DIRECT_DEPOSIT_FORM'), subtitle: getLocalizedString('ACCOUNT_SELECTION_SUBTITLE'), "data-testid": "DDFormMultipleAccountSelection" },
                React.createElement(React.Fragment, null))),
        React.createElement(ContentFrame, null,
            React.createElement(TemplateForm, { fieldConfigs: [userField], onSubmit: handleSubmit, submitButtonEventId: "DDForm-accountSelection" }))));
};
export default MultipleAccountSelection;
